import alliander from './Alliander.png'
import aae from './AAE.png'
import asml from './asml.png'
import bam from './BAM.webp'
import baeken from './Kopie van Baeken_Logo_DEF-CMYK.png'
import bol from './bol.png'
import bulsink from './bulsink.png'
import capgemini from './Capgemini.png'
import demcon from './logo-demcon_fc.800x0.png'
import daf from './DAF.png'
import datenna from './datenna.jpg'
import eneco from './Eneco.png'
import equans from './Equans.png'
import heijmans from './Heijmans.png'
import klm from './KLM_logo.svg.png'
import nxp from './NXP.png'
import shell from './Shell_logo.svg.png'
import shimano from './Shimano.png'
import thermofisher from './thermofisher.png'
import tno from './TNO.png'
import valcon from './Kopie van Valcon-CMYK-Dark-Grey-300DPI.png'
import youngcolfield from './LOGO young colfield.png'

const partnerLogos = {alliander: alliander,aae:aae, asml:asml, baeken:baeken, bam:bam,bol:bol,bulsink:bulsink, capgemini:capgemini,daf:daf,datenna:datenna,demcon:demcon,eneco:eneco,equans:equans,heijmans:heijmans,klm:klm,nxp:nxp,shell:shell,shimano:shimano,thermofisher:thermofisher,tno:tno,valcon:valcon,youngcolfield:youngcolfield}

export default partnerLogos